'use strict';

exports.__esModule = true;
exports.default = {
    AUTOCOMPLETE: 'autocomplete',
    RECENT: 'recent'
};